var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAscending(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ascending",
    transform: "translate(-1256 -2620)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_5352",
    "data-name": "Rectangle 5352",
    transform: "translate(1256 2620)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 20,
    height: 20,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "short-default",
    transform: "translate(904 348)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon2",
    d: "M5.058.483a.6.6,0,0,1,.885,0l4.136,4.512A.6.6,0,0,1,9.636,6H1.364A.6.6,0,0,1,.922,4.995Z",
    transform: "translate(357 2275)",
    fill: "#fd741f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon1",
    d: "M5.058.483a.6.6,0,0,1,.885,0l4.136,4.512A.6.6,0,0,1,9.636,6H1.364A.6.6,0,0,1,.922,4.995Z",
    transform: "translate(368.052 2289.096) rotate(180)",
    fill: "#6d809f"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAscending);
export default __webpack_public_path__ + "static/media/ascending.dc6c4a37aa8247b12d9f897ec31c4d45.svg";
export { ForwardRef as ReactComponent };